
import request from '@/utils/request'

// 账号密码登录
export function sendSmsCode(data) {
  return request({
    url: '/common/api/sendSmsCode',
    method: 'post',
    data
  })
}


// 获取省市区
export function getCity(data) {
  return request({
    url: '/common/api/getCity',
    method: 'post',
    data
  })
}

// 轮播图
export function getBanner(data) {
  return request({
    url: '/common/api/getBanner',
    method: 'post',
    data
  })
}


// 会员信息列表
export function getVipList(data) {
  return request({
    url: '/equipment/vip/vipList',
    method: 'post',
    data
  })
}

// 开通/续费会员
export function openVip(data) {
  return request({
    url: '/equipment/vip/openVip',
    method: 'post',
    data
  })
}

// 发起举报
export function initiateReport(data) {
  return request({
    url: '/equipment/report/initiateReport',
    method: 'post',
    data
  })
}


// 查询举报类型
export function getReportList(query) {
  return request({
    url: '/equipment/reportType/list',
    method: 'get',
    params: query
  })
}

//查询举报列表
export function reportList(query) {
  return request({
    url: '/equipment/report/list',
    method: 'get',
    params: query
  })
}

// 系统参数
export function getParam(data) {
  return request({
    url: '/common/api/getParam',
    method: 'post',
    data
  })
}

//微信 支付
export function wxPay(data) {
  return request({
    url: '/equipment/pay/unifiedOrderPay',
    method: 'post',
    data
  })
}






// 微信支付轮询
export function wxPayjjjjjj(data) {
  return request({
    url: '/equipment/pay/wxQuerry',
    method: 'post',
    data
  })
}


